// import ModalForm from "./Form";
import ClassTrialBehaviorTableForm from "./ClassTrialBehaviorTableForm";
import {
	PLACEMENT_BEHAVIOR,
	STUDENT,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";

export const ClassTrialBehaviorTableSchema = {
	components: { ClassTrialBehaviorTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: PLACEMENT_BEHAVIOR + "?placement_id=" + this.placementId,
			tableId: "class-trial-behavior-table",
			formId: "class-trial-behavior-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Behavior",
					type: "text",
					key: "behavior",
				},
				{
					title: "Score",
					// type: "text",
					type: "custom-html",
					key: "score",
					isVisible: true,
					modifier: (value) => {
						let html = "";
						let star = "";
						let maxStar = 5;
						let score = value;
						let emptyStarCount = maxStar - score;

						for (let i = 0; i < score; i++) {
							star += `<i class="fas fa-star text-warning"></i>`;
						}

						for (let i = 0; i < emptyStarCount; i++) {
							star += `<i class="far fa-star text-warning"></i>`;
						}

						html = `<div>${star}</div>`;
						return html;
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ClassTrialBehaviorTable",
				url: PLACEMENT_BEHAVIOR + "?placement_id=" + this.placementId,
				showHeader: true,
				enableHighlights: false,
				enableRowSelect: false,
				enableSaveFilter: false,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "class-trial-behavior-table-form",
						modalId: "class-trial-behavior-table-form",
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: false,
				showClearFilter: false,
				paginationType: "false",
				responsive: true,
				rowLimit: 4,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
